import React from "react";
import { useParams } from "react-router-dom";

import { useOrganizationCapabilities } from "components/RequirePermission/useCapabilities";

import UserCountDisplay from "../userCountDisplay";

import "./SideNav.css";

const SideNav = ({
  filter,
  setFilter,
  joinedCount,
  rejectedCount,
  removeRequestedCount,
  removedCount,
  requestedCount,
}) => {
  const { orgId } = useParams();
  // "Removed" is a viewing capability, not an edit action, so it's gated on
  // organization:id:read (not organization:id:update, a read/edit semantic
  // fix from the original role-based check). Permission-only, no raw
  // role-name check: OrganizationOwner passes today because that role's own
  // permissions[] grant organization:id:read, not because of the role name
  // itself. useOrganizationCapabilities is already scoped to THIS org's role
  // (see useEffectiveOrgPermission): it checks the specific role
  // useEffectiveOrgRole(orgId) reports for this org against THAT role's own
  // permissions, not the user's global cross-org union — a per-org Owner
  // assignment on a DIFFERENT org can't leak in here.
  const { canReadOrganizationById } = useOrganizationCapabilities(orgId);
  const isOwner = canReadOrganizationById;

  return (
    <div
      style={{
        // border: "1px black solid",
        paddingRight: "2rem",
        paddingTop: "0",
      }}
    >
      <div
        style={{
          border: "1px solid #d0d7de",
          display: "flex",
          flexDirection: "column",
          borderRadius: "8px",
          color: "black",
        }}
      >
        <div className="side-nav-filter-header">Filter Types of Users</div>
        {/* Joined Tab */}
        <div
          className={
            "side-nav-filter-option " +
            (filter === "Joined" && "side-nav-filter-option-joined-active")
          }
          onClick={() => setFilter("Joined")}
        >
          <p
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "0px",
            }}
          >
            Joined
          </p>
          <UserCountDisplay count={joinedCount} backgroundColor={"#afb8c133"} />{" "}
        </div>
        {/* Requested Tab */}
        <div
          className={
            "side-nav-filter-option " +
            (filter === "Requested" &&
              "side-nav-filter-option-requested-active")
          }
          onClick={() => setFilter("Requested")}
        >
          <p
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "0px",
            }}
          >
            Requested
          </p>
          <UserCountDisplay
            count={requestedCount}
            backgroundColor={"#afb8c133"}
          />{" "}
        </div>
        {/* Remove Requested Tab */}
        <div
          className={
            "side-nav-filter-option " +
            (filter === "Remove-Requested" &&
              "side-nav-filter-option-removeRequested-active")
          }
          onClick={() => setFilter("Remove-Requested")}
        >
          <p
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "0px",
            }}
          >
            Removals Requested
          </p>
          <UserCountDisplay
            count={removeRequestedCount}
            backgroundColor={"#afb8c133"}
          />{" "}
        </div>
        {/* Rejected Tab */}
        <div
          className={
            "side-nav-filter-option " +
            (filter === "Rejected" && "side-nav-filter-option-rejected-active")
          }
          onClick={() => setFilter("Rejected")}
        >
          <p
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "0px",
            }}
          >
            Rejected
          </p>
          <UserCountDisplay
            count={rejectedCount}
            backgroundColor={"#afb8c133"}
          />{" "}
        </div>
        {/* Removed Tab */}
        {isOwner && (
          <div
            className={
              "side-nav-filter-option " +
              (filter === "Removed" && "side-nav-filter-option-removed-active")
            }
            style={{ borderBottom: "none" }}
            onClick={() => setFilter("Removed")}
          >
            <p
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "0px",
              }}
            >
              Removed
            </p>
            <UserCountDisplay
              count={removedCount}
              backgroundColor={"#afb8c133"}
            />{" "}
          </div>
        )}
      </div>
    </div>
  );
};

export default SideNav;
